// extracted by mini-css-extract-plugin
export var banner = "_qh-0";
export var settingRow = "_qh-2";
export var titleIcon = "_qh-1";